export default "__VITE_ASSET__BDmj73_m__"